import { SelectionChange } from "event-definitions"
import { useRefresh } from "lib/@hooks/useRefresh"

const selections = {}

export function select(value, type = "general") {
    if (Object.isEqual(selections[type], value)) return value
    selections[type] = value
    setTimeout(() => SelectionChange.subEvent(type).raise())

    return value
}

export function useSelection(type = "general") {
    SelectionChange.subEvent(type).useEvent(useRefresh())
    return selections[type]
}
